import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import OwnerCanAskAdjustmentsModificationModal from '../owner-can-ask-adjustments-modification-modal/OwnerCanAskAdjustmentsModificationModal'
import OwnerCurrentActionFooterContainer from '../../OwnerCurrentActionFooterContainer'
import { Icon } from '../../../../../../../atoms'
import { IProposalInteractionsProps } from '../../../../../../../organisms/proposal/Proposal'
import PingPongButton from '../../../../../../../organisms/proposal/proposal-cta/buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../../../../../organisms/proposal/proposal-cta/utils/ping-pong-button-type.enum.ts'

interface IOwnerCanConfirmAdjustmentsFooterProps {
  ownerActions: IProposalInteractionsProps['ownerActions']
  clientProposalId: string
  ownerAskedAdjustmentsModificationAt: Date
}

const OwnerCanConfirmAdjustmentsFooter = ({
  ownerActions,
  clientProposalId,
  ownerAskedAdjustmentsModificationAt,
}: IOwnerCanConfirmAdjustmentsFooterProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false)

  if (!ownerActions) {
    return null
  }

  return (
    <OwnerCurrentActionFooterContainer>
      <PingPongButton
        type={PingPongButtonTypeEnum.CONFIRM}
        label={
          <FormattedMessage
            id='ui.OwnerCanConfirmAdjustmentsFooter.confirmButton.label'
            defaultMessage='Accepter les ajustements'
          />
        }
        onClick={() =>
          ownerActions.ownerConfirmedAdjustments.callback({ clientProposalId })
        }
        isLoading={ownerActions.ownerConfirmedAdjustments.isLoading}
      />

      {!ownerAskedAdjustmentsModificationAt ? (
        <PingPongButton
          type={PingPongButtonTypeEnum.DECLINED_BY_OWNER}
          label={
            <FormattedMessage
              id='ui.OwnerCanConfirmAdjustmentsFooter.modifyAdjustments.label'
              defaultMessage='Modifier les ajustements'
            />
          }
          onClick={() => setIsOpenModal(true)}
        />
      ) : (
        <div className='flex flex-col gap-2'>
          <PingPongButton
            type={PingPongButtonTypeEnum.WAITING}
            label={
              <FormattedMessage
                id='ui.OwnerCanConfirmAdjustmentsFooter.adjustmentsModificationAsked.label'
                defaultMessage='Demande de modification envoyée'
              />
            }
            hideIcon={true}
          />
          <button
            onClick={() => setIsOpenModal(true)}
            className='text-blue-300 flex items-center gap-1 text-[#1067EB] hover:underline'
          >
            <Icon name='reset' size={14} />
            Renvoyer une demande de modifications
          </button>
        </div>
      )}

      {isOpenModal && (
        <OwnerCanAskAdjustmentsModificationModal
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          ownerActions={ownerActions}
          clientProposalId={clientProposalId}
        />
      )}
    </OwnerCurrentActionFooterContainer>
  )
}

export default OwnerCanConfirmAdjustmentsFooter
